import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Shop from './components/Shop/Shop';

function App() {
  return (
    <div>
      <Header></Header>
      <Shop></Shop>
      <footer>
        All right reserved by @Follow Profile
      </footer>
    </div>
  );
}

export default App;
